import { useEffect, useState } from 'react';
import { Navigate } from 'react-router';
import { Flex, Spinner } from '@chakra-ui/react';
import { useAuth } from '../hooks/useAuth';
import { getMyBusinesses, createBusiness } from '../api/business';
import { saveSelectedBusiness } from '../utils/businessStorage';

const RootRedirect = () => {
  const { user, isLoading } = useAuth();
  const [redirectTo, setRedirectTo] = useState<string | null>(null);

  useEffect(() => {
    if (isLoading || !user) return;

    const resolve = async () => {
      try {
        let businesses = await getMyBusinesses();

        if (businesses.length === 0) {
          const newBiz = await createBusiness({ name: 'My Restaurant' });
          businesses = [newBiz];
        }

        const biz = businesses[0];
        saveSelectedBusiness({
          id: biz.id,
          name: biz.name,
          is_owner: biz.is_owner,
          is_onboarding_complete: biz.is_onboarding_complete,
        });
        setRedirectTo(`/businesses/${biz.id}/menus`);
      } catch {
        setRedirectTo('/login');
      }
    };

    resolve();
  }, [user, isLoading]);

  if (!user && !isLoading) {
    return <Navigate to="/login" replace />;
  }

  if (redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }

  return (
    <Flex minHeight="100vh" justifyContent="center" alignItems="center" backgroundColor="neutral.900">
      <Spinner size="xl" color="neutral.300" />
    </Flex>
  );
};

export default RootRedirect;
